<template>
  <div class="create-merchant">
    <v-stepper v-model="e1">
      <v-stepper-header>
        <v-stepper-step :complete="e1 > 1" step="1">
          Step 1
        </v-stepper-step>

        <v-divider></v-divider>

        <v-stepper-step :complete="e1 > 2" step="2">
          step 2
        </v-stepper-step>

      
      </v-stepper-header>

      <v-stepper-items>
        <v-stepper-content step="1">
          <ValidationObserver ref="observer1">
            <div class="stepper-form-content">
              <v-row class="row-no-pad">
                <v-col cols="12" md="12">
                  <ValidationProvider
                    class="input-wrapper"
                    v-slot="{ errors }"
                    name="CompanyName"
                    rules="required"
                  >
                    <v-text-field
                      label="Company Name"
                      class="custom-filled"
                      name="CompanyName"
                      v-model="merchantForm.companyName"
                    ></v-text-field>
                    <span class="error-message">{{ errors[0] }}</span>
                  </ValidationProvider>
                </v-col>

                <v-col cols="12" md="12">
                  <ValidationProvider
                    class="input-wrapper"
                    v-slot="{ errors }"
                    name="companyURL"
                    rules="required"
                    
                  >
                    <v-text-field
                      label="Company URL"
                      class="custom-filled"
                      name="companyURL"
                      v-model="merchantForm.companyUrl"
                    ></v-text-field>
                    <span class="error-message">{{ errors[0] }}</span>
                  </ValidationProvider>
                </v-col>

                <v-col cols="12" md="12">
                  <ValidationProvider
                    class="input-wrapper"
                    v-slot="{ errors }"
                    name="organizationId"
                    rules="required"
                  >
                    <v-text-field
                      label="Organization ID"
                      class="custom-filled"
                      name="organizationId"
                      v-model="merchantForm.organizationId"
                    ></v-text-field>
                    <span class="error-message">{{ errors[0] }}</span>
                  </ValidationProvider>
                </v-col>

                <v-col cols="12" md="12">
                  <ValidationProvider
                    class="input-wrapper"
                    v-slot="{ errors }"
                    name="profileName"
                    rules="required"
                  >
                    <v-text-field
                      label="Profile Name"
                      class="custom-filled"
                      v-model="merchantForm.profileName"
                    ></v-text-field>
                    <span class="error-message">{{ errors[0] }}</span>
                  </ValidationProvider>
                </v-col>
                <v-col cols="12" md="12">
                  <ValidationProvider
                    class="input-wrapper"
                    v-slot="{ errors }"
                    name="profileDescription"
                    rules="required"
                  >
                    <v-text-field
                      label="Profile Description"
                      class="custom-filled"
                      name="profileDescription"
                      v-model="merchantForm.profileDescription"
                    ></v-text-field>
                    <span class="error-message">{{ errors[0] }}</span>
                  </ValidationProvider>
                </v-col>
              </v-row>
            </div>

            <v-btn text @click.prevent="cancelCreate">
              Cancel
            </v-btn>
            <v-btn color="primary" @click="goToNext(1)">
              Next
            </v-btn>
          </ValidationObserver>
        </v-stepper-content>

        <v-stepper-content step="2">
          <ValidationObserver ref="observer2">
            <div class="stepper-form-content">
              <v-row class="row-no-pad">
                

                <v-col cols="12" md="12">
                  <ValidationProvider
                    class="input-wrapper"
                    v-slot="{ errors }"
                    name="contactPerson"
                    rules="required"
                  >
                    <v-text-field
                      label="Contact Person"
                      name="contactPerson"
                      class="custom-filled"
                      v-model="merchantForm.contactPerson"
                    ></v-text-field>
                    <span class="error-message">{{ errors[0] }}</span>
                  </ValidationProvider>
                </v-col>

                <v-col cols="12" md="12">
                  <ValidationProvider
                    class="input-wrapper"
                    v-slot="{ errors }"
                    name="notificationEmail"
                    rules="required|email"
                  >
                    <v-text-field
                      label="Notification Email"
                      class="custom-filled"
                      name="notificationEmail"
                      v-model="merchantForm.notificationEmail"
                    ></v-text-field>
                    <span class="error-message">{{ errors[0] }}</span>
                  </ValidationProvider>
                </v-col>

                <v-col cols="12" md="12">
                  <ValidationProvider
                    class="input-wrapper"
                    v-slot="{ errors }"
                    name="notificationMobileNumber"
                    rules="required|phone"
                  >
                    <v-text-field
                      label="Notification Mobile Number"
                      class="custom-filled"
                      name="notificationMobileNumber"
                      v-model="merchantForm.notificationMobileNumber"
                    ></v-text-field>
                    <span class="error-message">{{ errors[0] }}</span>
                  </ValidationProvider>
                </v-col>
              </v-row>
            </div>

            <v-btn text @click.prevent="cancelCreate">
              Cancel
            </v-btn>
            <v-btn color="grey lighten-1" @click="e1 = 1">
              Back
            </v-btn>
            <v-btn color="primary" @click.prevent="createMerchant">
              Submit
            </v-btn>
          </ValidationObserver>
        </v-stepper-content>

        
      </v-stepper-items>
    </v-stepper>
  </div>
</template>
<script>
import Promise from "../../../../../../lib/mixins/ExtendedPromises";
import Merchant from "../../../../../../repositories/adminMerchantController";
export default {
  name: "CreateMerchant",
  mixins: [Promise],
  data() {
    return {
      e1: 1,
      merchantForm: {
        companyName: "",
        companyUrl: "",
        organizationId: "",
        profileDescription: "",
        profileName: "",

        contactPerson: "",
        notificationEmail: "",
        notificationMobileNumber: "",

      
       
      }
    };
  },
  methods: {
    async goToNext(val) {
      let refName = `observer${val}`;
      const valid = await this.$refs[refName].validate();
      if (valid) {
        this.e1 = 1 + val;
      }
    },
    async createMerchant() {
       const valid = await this.$refs.observer2.validate();
       if(valid) {
          const operation = this.response(
        Merchant.createMerchant(this.merchantForm)
      );
      operation
        .then(response => {
          if (operation.isFulfilled()) {
            this.$toasted.show("Merchant Created Successfully");
            this.$emit('merchantCreated');
          }
        })
        .catch(err => {
          this.$toasted.show(err.data.message, {
            type: 'error'
          });
        });
       }

    },
    resetForm () {
      this.e1 = 1;
      for (const [key, value] of Object.entries(this.merchantForm)) {
        this.merchantForm[key] = "";
      }
      this.$nextTick(() => {
          this.$refs.observer1.reset();
          this.$refs.observer2.reset();
        });
    },
    cancelCreate() {
      this.e1 = 1;
      for (const [key, value] of Object.entries(this.merchantForm)) {
        this.merchantForm[key] = "";
      }
      this.$nextTick(() => {
          this.$refs.observer1.reset();
          this.$refs.observer2.reset();
        });
      this.$emit("cancelCreate");
    }
  }
};
</script>
